var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgArrowRightBlack(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 11.985,
    height: 12,
    viewBox: "0 0 11.985 12"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.91 5.619a1 1 0 00-.21-.33l-5-5a1.003 1.003 0 10-1.419 1.419l3.302 3.296H1a1 1 0 000 2h7.584l-3.3 3.287A1 1 0 106.7 11.704l5-5a1.033 1.033 0 00.21-1.089z",
    fill: "##08123B"
  })));
}

export default SvgArrowRightBlack;